import { Box, Loader, MessageModalLayout, Text } from '@wix/design-system';
import React from 'react';
import AlreadyDeliveredIllustration from '../../assets/already-delivered.svg';
import PendingIllustration from '../../assets/pending.svg';
import { DoublePurchaseModule } from '../../double-purchase.module';
export const DoublePurchaseModal = _ref => {
  let {
    onClose,
    onLoad,
    onConfirm
  } = _ref;
  const {
    siteGuid,
    productTypeId
  } = DoublePurchaseModule.internals.useContext();
  const {
    t
  } = DoublePurchaseModule.internals.useTranslations();
  const {
    isLoading,
    data
  } = DoublePurchaseModule.SDK.doublePurchaseApiClient.hooks.useCheckDoublePurchase({
    siteGuid,
    productTypeId
  });
  const reason = (data == null ? void 0 : data.status) === 'DELIVERED' ? 'already-delivered' : 'pending';
  React.useEffect(() => {
    onLoad == null || onLoad({
      reason
    });
  }, [onLoad]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  const explanationKey = (data == null ? void 0 : data.status) === 'DELIVERED' ? 'double_purchase_validation.alreadyUpgradedPlan_alreadyDelivered_dynamic' : 'double_purchase_validation.alreadyUpgradedPlan_pendingDelivery_dynamic';
  const confirmButtonKey = (data == null ? void 0 : data.status) === 'DELIVERED' ? 'double_purchase_validation.viewPlanButton' : 'double_purchase_validation.manageSiteButton';
  const illustration = (data == null ? void 0 : data.status) === 'DELIVERED' ? /*#__PURE__*/React.createElement(AlreadyDeliveredIllustration, null) : /*#__PURE__*/React.createElement(PendingIllustration, null);
  const handleClose = () => {
    onClose == null || onClose({
      reason
    });
    DoublePurchaseModule.SDK.modalsController.DoublePurchaseModal.hide();
  };
  const handleConfirm = () => {
    onConfirm == null || onConfirm({
      reason
    });
    const myAccountUrl = '/my-account/'; // TODO: Get it from statics
    const redirectUrl = `${myAccountUrl}sites/${siteGuid}`;
    if ((data == null ? void 0 : data.status) === 'DELIVERED') {
      window.location.assign(`${redirectUrl}/manage-premium/plans/`);
    } else {
      window.location.assign(redirectUrl);
    }
  };
  return /*#__PURE__*/React.createElement(MessageModalLayout, {
    title: t('double_purchase_modal.title'),
    primaryButtonOnClick: handleConfirm,
    primaryButtonText: t(confirmButtonKey),
    onCloseButtonClick: handleClose,
    illustration: illustration
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(Text, null, t('double_purchase_validation.alreadyUpgradedPlan')), /*#__PURE__*/React.createElement(Text, null, t(explanationKey))));
};
//# sourceMappingURL=DoublePurchaseModal.js.map